package com.xtream.composeapp.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import androidx.paging.Pager
import androidx.paging.PagingConfig
import androidx.paging.PagingData
import androidx.paging.PagingSource
import androidx.paging.cachedIn
import com.xtream.data_kmp.AllConst.PAGING_PAGE_SIZE
import com.xtream.data_kmp.db.repo.LiveStreamsRepository
import com.xtream.data_kmp.db.repo.SearchStreamsRepository
import com.xtream.data_kmp.db.repo.SeriesStreamsRepository
import com.xtream.data_kmp.db.repo.VodStreamsRepository
import com.xtream.data_kmp.dto.CategoryBase
import com.xtream.data_kmp.dto.LiveStream
import com.xtream.data_kmp.dto.SeriesStream
import com.xtream.data_kmp.dto.VodStream
import com.xtream.data_kmp.util.extension.toggle
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.debounce
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.flow.update


interface SearchViewModelInterface {

    val searchFlow:MutableStateFlow<String?>
    val searchByCategoryFlow: MutableStateFlow<Int?>
    val selectedCategoriesFlow: MutableStateFlow<List<CategoryBase>?>

    fun search(query:String?){

        searchFlow.tryEmit(query)
    }
    fun searchByCategory(categoryId:Int?){
        searchByCategoryFlow.tryEmit(categoryId)
    }

    fun toggleCategory(category: CategoryBase){
        selectedCategoriesFlow.update { current ->
            (current ?: emptyList()).toggle(category)
        }
    }

}
class SearchViewModelImpl () :ViewModel(),SearchViewModelInterface{
  override  val searchFlow= MutableStateFlow<String?>(null)
  override  val searchByCategoryFlow= MutableStateFlow<Int?>(null)
   override val selectedCategoriesFlow: MutableStateFlow<List<CategoryBase>?> =  MutableStateFlow(null)
}


 class SearchViewModel (
     private val searchStreamsRepository: SearchStreamsRepository,
     private val liveStreamsRepository: LiveStreamsRepository,
     private val vodRepository: VodStreamsRepository,
     private val seriesRepository: SeriesStreamsRepository

) : ViewModel(),SearchViewModelInterface by SearchViewModelImpl() {
     val searchQuery = searchFlow.asStateFlow()
         .debounce(300)
         .distinctUntilChanged().stateIn(
         viewModelScope,
             started = SharingStarted.WhileSubscribed(5000),
             initialValue = ""
     )
     // 2. Stable Flows (These references never change, only their contents update)
     val liveStreamsFlow: Flow<PagingData<LiveStream>> = searchQuery
         .debounce(300)
         .distinctUntilChanged()
         .flatMapLatest { query ->
             // This lambda runs when query changes. It returns a new Paging Flow.
             // flatMapLatest switches to this new flow automatically.
            // Log.d("SearchViewModel", "Switching to new flow for query: $query")
             getPager { liveStreamsRepository.getStreamsAsPagingSource(categoryId = null, query) }.flow
         }
         .cachedIn(viewModelScope)

     val vodStreamsFlow: Flow<PagingData<VodStream>> = searchQuery
         .debounce(300)
         .distinctUntilChanged()
         .flatMapLatest { query ->
             getPager { vodRepository.getStreamsAsPagingSource(categoryId =null, query) }.flow
         }
         .cachedIn(viewModelScope)

     val seriesStreamsFlow: Flow<PagingData<SeriesStream>> = searchQuery
         .debounce(300)
         .distinctUntilChanged()
         .flatMapLatest { query ->
             getPager { seriesRepository.getStreamsAsPagingSource(categoryId =null, query) }.flow
         }
         .cachedIn(viewModelScope)
     private fun  <Key : Any, Value : Any> getPager(   pagingSourceFactory: () -> PagingSource<Key, Value>  ) : Pager<Key, Value> {
         return Pager(PagingConfig(
             pageSize = PAGING_PAGE_SIZE,
             enablePlaceholders = false,

             ),

             pagingSourceFactory = pagingSourceFactory)
     }

}
